import { Vue, Component, Prop } from 'vue-property-decorator';
import { isMicroStandardId, getTaxonomyTags } from '@/utils/utils';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import TaxonomyCard from '../taxonomy-card/taxonomy-card';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
    name: 'question-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'taxonomy-card': TaxonomyCard,
    },
})

export default class QuestionCard extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private question: any;

    @Prop({ default: false })
    private isMyContent!: boolean;

    get tags() {
        return this.question.standards;
    }

    // -------------------------------------------------------------------------------
    // Actions
    private onPlayQuestion(questionId: string) {
        const playerURL = `${window.location.origin}/library/content/questions/play/${questionId}?source=rgo`;
        this.$emit('onOpenPlayer', playerURL);
    }

    private editQuestion(questionId: string) {
        const currentRoute = this.$router.currentRoute.path;
        const playerURL = `${window.location.origin}/library/content/questions/edit/${questionId}?editing=true&redirectUrl=${currentRoute}`;
        window.location.href = playerURL;
    }

    private openPullout() {
        this.$emit('openPullout', this.question);
    }


    private filterCreator(creator: any) {
        this.$emit('filterCreator', creator);
    }
}
